import { GetReportButton } from './GetReportButton';

export default GetReportButton;
